import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useTheme } from '../../contexts/ThemeContext';
import { useThemeClassName } from '../../contexts/ThemeContext';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/todays-points.module.scss';

const propTypes = {
    className: PropTypes.string,
    points: PropTypes.number,
};

const defaultProps = {
    className: null,
    points: null,
};

function TodaysPoints({ className, points }) {
    const themeClassName = useThemeClassName(styles);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                { [className]: className !== null },
            ])}
        >
            <div className={styles.label}>
                <FormattedMessage
                    defaultMessage="Points earned today"
                    description="TodaysPoints label"
                />
            </div>
            <div className={styles.points}>
                <span className={styles.pointsInner}>
                    <FormattedMessage
                        defaultMessage="{count, plural, =0 {# pt} one {# pt} other {# pts}}"
                        description="pts label"
                        values={{ count: points || 0 }}
                    />
                </span>
            </div>
        </div>
    );
}

TodaysPoints.propTypes = propTypes;
TodaysPoints.defaultProps = defaultProps;

export default TodaysPoints;
